
import React from 'react';
import { useTheme } from '../ThemeContext';

function Sidebar({ activeSection, setActiveSection, isCollapsed, setIsCollapsed, cerrarSesionGeneral }) {
  const { colors, isDarkMode } = useTheme();

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊' },
    { id: 'conductores', label: 'Conductores', icon: '👨‍💼' },
    { id: 'reporte-total-general', label: 'Reporte Total General', icon: '📈' },
    { id: 'operadores', label: 'Operadores', icon: '👥' },
    { id: 'reservas', label: 'Reservas', icon: '📅' },
    { id: 'whatsapp-web', label: 'WhatsApp Web', icon: '📱' },
    { id: 'ubicaciones', label: 'Ubicaciones', icon: '📍' }
  ];

  return (
    <div style={{
      width: isCollapsed ? '70px' : '250px',
      background: colors.sidebarBg,
      color: colors.sidebarText,
      borderRight: isDarkMode ? 'none' : `1px solid ${colors.sidebarBorder}`,
      padding: '20px 0',
      transition: 'width 0.3s ease',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Header */}
      <div style={{
        padding: '0 20px',
        marginBottom: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          marginBottom: '10px'
        }}>
          <img
            src="/logo_taxiservicios.png"
            alt="Plaza Del Valle Logo"
            style={{
              width: isCollapsed ? '40px' : '90px',
              height: isCollapsed ? '40px' : '65px',
              borderRadius: '8px',
              objectFit: 'contain',
              border: `2px solid ${colors.primary}`
            }}
          />
        </div>
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          style={{
            background: 'none',
            border: 'none',
            color: colors.sidebarText,
            fontSize: '20px',
            cursor: 'pointer',
            padding: '5px',
            borderRadius: '4px'
          }}
        >
          {isCollapsed ? '→' : '←'}
        </button>
      </div>

      {/* Menu Items */}
      <nav style={{ flex: 1 }}>
        {menuItems.map((item) => (
          <div
            key={item.id}
            onClick={() => setActiveSection(item.id)}
            style={{
              padding: '15px 20px',
              cursor: 'pointer',
              background: activeSection === item.id ? colors.sidebarActive : 'transparent',
              borderLeft: activeSection === item.id ? `4px solid ${colors.primary}` : '4px solid transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '15px',
              transition: 'all 0.2s ease',
              color: colors.sidebarText
            }}
            onMouseEnter={(e) => {
              if (activeSection !== item.id) {
                e.currentTarget.style.background = colors.sidebarHover;
              }
            }}
            onMouseLeave={(e) => {
              if (activeSection !== item.id) {
                e.currentTarget.style.background = 'transparent';
              }
            }}
          >
            <span style={{ fontSize: '20px' }}>{item.icon}</span>
            {!isCollapsed && (
              <span style={{
                fontSize: '16px',
                fontWeight: activeSection === item.id ? 'bold' : 'normal'
              }}>
                {item.label}
              </span>
            )}
          </div>
        ))}
      </nav>

      {/* Botón de cerrar sesión en la parte inferior */}
      <div style={{
        padding: '20px',
        borderTop: `1px solid ${colors.sidebarBorder}`,
        marginTop: 'auto'
      }}>
        <button
          onClick={cerrarSesionGeneral}
          style={{
            width: '100%',
            padding: '12px',
            background: colors.danger, // Softer red
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            transition: 'background-color 0.2s'
          }}
          onMouseEnter={(e) => e.target.style.background = colors.dangerHover}
          onMouseLeave={(e) => e.target.style.background = colors.danger}
        >
          <span>🔌</span>
          {!isCollapsed && <span>Cerrar Sesión</span>}
        </button>
      </div>
    </div>
  );
}

export default Sidebar;